var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0698 2C7.40391 2 2.00012 7.40379 2.00012 14.0697C2.00012 20.7356 7.40391 26.1394 14.0698 26.1394C20.7357 26.1394 26.1395 20.7356 26.1395 14.0697C26.1395 7.40379 20.7357 2 14.0698 2ZM0.00012207 14.0697C0.00012207 6.29922 6.29935 0 14.0698 0C21.8403 0 28.1395 6.29922 28.1395 14.0697C28.1395 21.8402 21.8403 28.1394 14.0698 28.1394C6.29935 28.1394 0.00012207 21.8402 0.00012207 14.0697ZM14.0694 9.71318C14.9717 9.71318 15.7031 8.98174 15.7031 8.07947C15.7031 7.17719 14.9717 6.44575 14.0694 6.44575C13.1671 6.44575 12.4357 7.17719 12.4357 8.07947C12.4357 8.98174 13.1671 9.71318 14.0694 9.71318ZM12.9808 11.9806C12.4285 11.9806 11.9808 12.4283 11.9808 12.9806C11.9808 13.5328 12.4285 13.9806 12.9808 13.9806H13.0699V20.6046C13.0699 21.1568 13.5177 21.6046 14.0699 21.6046H15.1591C15.7114 21.6046 16.1591 21.1568 16.1591 20.6046C16.1591 20.0523 15.7114 19.6046 15.1591 19.6046H15.0699V12.9806C15.0699 12.4283 14.6222 11.9806 14.0699 11.9806H12.9808Z",
    fill: "#1D474F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0e8c35ecf21c7c46ebd74619b21647cc.svg";
export { ForwardRef as ReactComponent };